export default __webpack_public_path__ + "static/media/search.f06ac291.svg";